var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"temp"},[_c('dv-scroll-board',{ref:"workerStatusScroll",staticStyle:{"height":"90%"},attrs:{"config":_vm.workerStatusScrollConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }